import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { borderRadius } from '@infl-ts/ui-advocate-theme';
import { CircularProgress, styled, TextField } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var FilledTextField = styled(TextField)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border-radius: ", ";\n"])), function (props) {
  return props.theme.palette.common.white;
}, function (props) {
  return borderRadius(props.theme);
});

var CustomTextField = function CustomTextField(_ref) {
  var params = _ref.params,
      loading = _ref.loading;
  return /*#__PURE__*/_jsx(FilledTextField, _objectSpread(_objectSpread({}, params), {}, {
    variant: "outlined",
    InputProps: _objectSpread(_objectSpread({}, params.InputProps), {}, {
      endAdornment: /*#__PURE__*/_jsxs(_Fragment, {
        children: [loading && /*#__PURE__*/_jsx(CircularProgress, {
          size: 20
        }), params.InputProps.endAdornment]
      })
    }),
    placeholder: "Filter by Group",
    "data-element": "FilledTextField",
    "data-component": "CustomTextField",
    "data-source-file": "custom-text-field.tsx"
  }));
};

export default CustomTextField;